import Timeline from '../Timeline';
import Header from './Header';
import ActiveItem from '../ActiveItem';
import classes from './Layout.module.css';
import getEpgData from '../../tools/getEpgData';
import { useEffect, useState, useCallback } from 'react';
import moment from 'moment';
import { ScaleLoader } from 'react-spinners';
import { useParams } from 'react-router-dom';

function Layout() {
    const [klhItems, setKLHItems] = useState([]);
    const [msItems, setMsItems] = useState([]);
    const [activeItem, setActiveItem] = useState(null);
    const [stationName, setStationName] = useState('');
    const [typeOfCal, setTypeOfCal] = useState('שידורים'); // type of calander showing "שידורים" "הקלטות" "ישיבות"
    const [isLoading, setIsLoading] = useState(false);

    const params = useParams();

    const updateItems = useCallback(() => {
        setIsLoading(true);
        getEpgData(params.stationName).then((data) => {
            setKLHItems(Object.values(data.EPG)[0] || []);
            setMsItems(data['OutlookData'] || []);
            if (data['MeetingRoom']) {
                setTypeOfCal('ישיבות');
            }
            if (data['OutlookData'] && !data['MeetingRoom']) {
                setTypeOfCal('הקלטות');
            }

            setStationName(data.StationName);
            setIsLoading(false);
        });
    }, [params]);

    const findActiveItems = useCallback(() => {
        const klhActive = klhItems.find((elm) => moment().isBetween(moment(elm.startTime), moment(elm.endTime), 's', '[)'));
        const MSActive = msItems.find((elm) => moment().isBetween(moment(elm.startTime), moment(elm.endTime), 's', '[)'));
        setActiveItem({
            klh: klhActive,
            ms: MSActive,
            meetingRoom: typeOfCal === 'ישיבות',
        });
    }, [klhItems, msItems, typeOfCal]);

    useEffect(() => {
        setInterval(() => {
            updateItems();
        }, 1000 * 60 * 10);
    }, [updateItems]);

    useEffect(() => {
        updateItems();
    }, [updateItems]);

    useEffect(() => {
        findActiveItems();
    }, [findActiveItems]);

    useEffect(() => {
        const interval = setInterval(() => {
            findActiveItems();
        }, 1000 * 60);
        return () => {
            clearInterval(interval);
        };
    }, [findActiveItems]);

    return (
        <div className={classes.container}>
            <Header station={stationName} />
            {(klhItems.length > 0 || msItems.length > 0) && <ActiveItem eventData={activeItem} />}

            {/* {klhItems.length === 0 && msItems.length === 0 && ( */}
            {isLoading && (
                <ScaleLoader
                    height={150}
                    width={7}
                    color="black"
                    cssOverride={{
                        display: 'block',
                        gridArea: '3/1/4/2',
                        margin: 'auto',
                        marginTop: '5rem',
                    }}
                />
            )}
            {/* {(klhItems.length > 0 || msItems.length > 0) && ( */}
            {!isLoading && <Timeline klhFetchedData={klhItems} msFetchedData={msItems} typeOfCal={typeOfCal} />}
        </div>
    );
}

export default Layout;
